// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"k2-z","sponsoredTooltipWrapper":"l2-z","sponsoredTooltip":"m2-z","newCard":"n2-z"};